import { SiteContext } from "../../../Contexts/SiteContext";

import Slider from '../../Slider/Slider';
import LazyLoad from '../../Image/LazyLoad';

const ProductModels = props => {
	const { block } = props;

	return (
		<SiteContext.Consumer>
			{({ dom }) => (
				<div className="customContainer">
					<div
						className="productModels"
						id={
							block.data.navTitle
								? block.data.navTitle.toLowerCase().replace(/ /g, "_")
								: ""
						}
					>
						<h2 className="cbTitle">{block.data.title}</h2>
						<div className="productModelsHolder">
							{dom.width && (
								<Slider
									bulletsIcons={"bullets"}
									items={dom.width > 1023 ? 3 : 1}
									gutter={20}
									children={block.data.children}
									tabletBullets={dom.width}
									autoNext={false}
									dots={dom.width > 1023 ? false : true}
									blockSelector={block.data.navTitle
										.toLowerCase()
										.replace(/ /g, "_")}
								>
									{block.data.children.map((car, i) => {
										return (
											<div
												className="productModel"
												key={`${props.blockSelector}-PM-${i}`}
											>
												<span></span>
												<div className="asset">
													<LazyLoad image={car.featureImage} alt={car.mainColor} blur={"product-blur"}/>
												</div>
												<div className="colours">
													<div
														className="main"
														style={{
															backgroundColor:
																car.mainColor
														}}
													></div>
													<div
														className="secondary"
														style={{
															backgroundColor:
																car.secondaryColor
														}}
													></div>
												</div>
												<div className="modelName">
													<span>{car.title}</span> <br />
													{car.fromPrice}
												</div>
											</div>
										);
									})}
								</Slider>
							)}
						</div>
					</div>
				</div>
			)}
		</SiteContext.Consumer>
	);
};

export default ProductModels;
